"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Icon_1 = __importDefault(require("@material-ui/core/Icon"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var framework_1 = require("../../../widgets/framework");
var PasswordResetSuccessStyle_1 = __importDefault(require("./PasswordResetSuccessStyle"));
var ActivationContent = function () {
    var _a;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, PasswordResetSuccessStyle_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var onNavigate = function () {
        var appNavigate = {
            action: 'LOGIN'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (react_1.default.createElement(Grid_1.default, { sm: 10, md: 10 },
        react_1.default.createElement("div", { className: classes.box },
            react_1.default.createElement(Icon_1.default, { className: (0, classnames_1.default)((_a = {},
                    _a[classes.icon] = true,
                    _a[classes.iconSuccess] = true,
                    _a)) }, "done"),
            react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.gotoText }, t('resetPassword.successMessage'))),
        react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.gotoText }, t('goTo')),
        react_1.default.createElement(Button_1.default, { size: "large", variant: "contained", color: "primary", "aria-label": "Sign In", onClick: onNavigate, className: classes.button }, t('login.signIn'))));
};
exports.default = ActivationContent;
//# sourceMappingURL=PasswordResetSuccess.js.map